const Images = ['jpg', 'jpeg', 'png', 'ico', 'svg', 'bmp', 'gif'];
const Archives = ['zip', 'rar', '7z'];
const Videos = ['mp4', 'mov', 'avi', 'wmv'];
const Apps = ['exe', 'apk', 'ipa'];

export {Images, Archives, Videos, Apps};